export default __webpack_public_path__ + "static/media/braces.f133c773.svg";